import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-cliente-fechamento',
  templateUrl: './form-cliente-fechamento.component.html',
  styleUrls: ['./form-cliente-fechamento.component.scss']
})
export class FormClienteFechamentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
